import styled, { css } from 'styled-components';
import { animated } from '@react-spring/web';

import Label from 'Elements/Label';

export const Wrapper = styled.div`
    position: relative;
`;

export const Icon = styled.svg`
    height: 1.25rem;
    width: 0.6rem;
    margin-left: 1rem;
    transition: all ease 0.25s;
`;

export const Dropdown = styled(animated.div)<{ $isOpen: boolean }>`
    ${({ theme, $isOpen }) => css`
        position: absolute;
        width: 100%;
        z-index: 3;
        color: var(--dropdown-color-left, ${theme.colors.text.hex});
        margin-bottom: 0rem;
        overflow: hidden;
        visibility: ${$isOpen ? 'visible' : 'hidden'};
        border-radius: 0 0 0.5rem 0.5rem;
        border: 0.1rem solid ${theme.colors.secondary.tints[2].hex};
        box-sizing: border-box;
        border-top: 0;
        transition: border ease 0.1s;
        background: ${theme.colors.primaryContrast.hex};
        transform-origin: top;

        & > * {
            margin: 1rem 0;
        }

        &:first-child {
            margin-top: 0.5rem;
        }

        & * {
            ::first-letter {
                text-transform: uppercase;
            }
        }
    `}
`;

export const Button = styled.button<{ $isOpen: boolean }>`
    ${({ theme, $isOpen }) => css`
        background: none;
        font-size: 1rem;
        border-radius: ${$isOpen ? '0.5rem 0.5rem 0 0' : '0.5rem'};
        border: 0.1rem solid
            ${$isOpen ? theme.colors.secondary.tints[2].hex : theme.colors.tertiary.hex};
        box-sizing: border-box;
        padding: 0.5rem 1.25rem 0.5rem 0.75rem;
        width: 100%;
        min-width: 10rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        transition: all ease 0.1s;
        background: ${theme.colors.primaryContrast.hex};

        ${$isOpen &&
        css`
            color: ${theme.colors.secondary.tints[2].hex};
            border: 0.1rem solid ${theme.colors.secondary.tints[2].hex};
            border-bottom: 0;
        `}

        ${Icon} {
            transform: ${$isOpen ? 'rotate(270deg)' : 'rotate(90deg)'};
        }
    `}
`;

export const StyledLabel = styled(Label)`
    ${({ theme }) => css`
        font-size: 0.875rem;
        margin-bottom: 0.5rem;
        display: block;
        color: var(--label-text-color, ${theme.colors.text.hex});
        font-weight: 300;

        @media ${theme.breakpoints.medium.media} {
            font-size: 1rem;
        }
    `}
`;
